<template>
  <div class="containerDashboard">
    <tool-bar-filter :dashboardId="dashboardId" :dynFilters="globalFilters.filter(x => x.destination === 'topBarFilter')" />
    <div class="containerDashboard__layout">
      <side-bar-filter :favorites="favorites" :dynFilters="globalFilters.filter(x => x.destination === 'sideBarFilter')" :dashboardId="dashboardId" class="container__side-filter" />
      <div  class="containerDashboard__dashboard">
        <dashboard-wrapper v-if="dashboard != null" id="inst1" :editmode="handleEditMode" :dashboard="dashboard" :token="token" :platformbase="platformbase" :initialDatalink="initialDatalink" i18n="true"></dashboard-wrapper>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import dashboardWrapper from '../components/dashboard/VueWrapperComponent'
import ToolBarFilter from '../components/dashboard/filter/ToolBarFilter'
import SideBarFilter from '../components/dashboard/filter/SideBarFilter'
import { HTTP_PLATFORM } from '../store/modules/http'

export default {
  name: 'Dashboard',
  components: {
    dashboardWrapper,
    ToolBarFilter,
    SideBarFilter
  },
  data: function () {
    return {
      dashboard: null,
      token: sessionStorage.sessionToken,
      platformbase: process.env.VUE_APP_PLATFORM, // http://localhost:8000 por nginx, 8080 contra lab https://lab.onesaitplatform.com
      params: {},
      api: {},
      jsongadget: {},
      i18n: false,
      currentDashboard: '',
      currentDashboardId: '',
      isAdmin: false,
      favorites: [],
      dashboardId: '',
      dashboardStarted: false,
      initialDatalink: {} // { 'external-entity': [{ field: 'codent', value: "'0062'", op: '=' }], 'external-segment': [{ field: 'segment', value: "('MEX_62_1')", op: 'IN' }] },      // Global Filters Info.
    }
  },
  watch: {
    '$route.params.dashboardId': {
      // Watch for dashboard
      immediate: true,
      handler (dashboardId) {
        // get internal id of dashboard
        var vapp = this
        const internalIdEndPoint = '/controlpanel/api/dashboards/dashboard/' + dashboardId
        HTTP_PLATFORM.get(internalIdEndPoint).then(function (response) {
          if (response && response.data.id) {
            // check for filters available on session, and trigger them for the new dashboard.
            vapp.currentDashboard = dashboardId
            vapp.currentDashboardId = response.data.id
            vapp.dashboardId = dashboardId
            // check initial filters and apply , then load the dashboard
            vapp.checkFilters()
          }
        })
      }
    }
  },
  // METHODS FROM DASHBOARDS
  methods: {
    // ACTIONS FROM STORES
    ...mapActions([
      'initGlobalFilters',
      'initDataFilter',
      'initDataRole',
      'checkInitialFilters',
      'filterDataFilter'
    ]),
    // LOAD DASHBOARD INTO VUEWRAPPER
    swapBoard (dashboardId) {
      this.dashboard = dashboardId
    },

    // SAVE DASHBOARD API
    saveDashboard () {
      window.DSApi.inst1.api.msgApi({ command: 'saveDashboard', authorization: this.token, information: { dashboard: this.dashboard } })
      this.$notify({
        title: 'Guardar Dashboard',
        message: 'El Dashboard has sido guardado correctamente',
        type: 'success',
        iconClass: 'ods-icon-save',
        duration: 2500,
        position: 'top-right',
        showClose: true
      })
      // clear cache after saving
      window.DSApi.inst1.api.clearCache(this.dashboard)
    },

    // LOAD FAVORITES
    loadFavorites () {
      var vapp = this
      var favoritesByApp = []
      const getAllEndPoint = '/controlpanel/api/favoritegadget/getallbyapp'
      var filterApp = 'app=' + this.getCurrentApplication

      // PLATFORM FAVORITES API CALL
      HTTP_PLATFORM.get(getAllEndPoint).then(function (response) {
        if (response.data.length > 0) {
          favoritesByApp = response.data.map(({ identification, metainf }) => ({ identification, metainf })).filter(x => x.metainf === filterApp)
        }
        vapp.favorites = []
        for (let i = 0; i < favoritesByApp.length; i++) {
          vapp.favorites.push({ id: favoritesByApp[i].identification, title: favoritesByApp[i].identification, type: 'favoritegadget' })
        }
      })
    },

    //  TO-DO: MAKE DYNAMICAL, INITIAL FILTERS DATA LOAD
    async loadFilters () {
      // NEW WAY TO LOAD DATA
      try {
        var userInfo = this.getUser
        const filterRole = await this.initDataRole({ user: userInfo.user, api: window.DSApi.inst1.api })
        console.log('FILTER ROLE: ', filterRole)
        var filters = this.getFilterList
        for (let i = 0; i < filters.length; i++) {
          // load data for each filter
          const setup = await this.initDataFilter(filters[i])
          console.log('setup for ' + filters[i] + ': ', JSON.stringify(setup))
          // check filters between fields
          // if field has filterTo, apply initially the filter for filters persistence
          var field = (this.getGlobalFilters).filter(x => x.id === filters[i])[0]
          if (field && field.schema.filterTo.length > 0 && field.filter.activeFilter) {
            var filtered = field.schema.filterTo
            for (let y = 0; y < filtered.length; y++) {
              var action = { id: filtered[y], field: field.filter.field, value: field.filter.activeFilter }
              this.filterDataFilter(action)
              // console.log('Apply persistence filter from ', filters[i], ' to: ', filtered[y])
            }
          }
        }
      } catch (error) {
        console.log(error)
        return error
      }
    },

    // DASHBOARD EVENT: gadget is loaded
    gadgetLoaded (e) {
      console.log('gadgetLoaded ', e.detail)
      if (!this.dashboardStarted) { this.dashboardStarted = true }
    },

    // DASHBOARD EVENT: dashboard loaded, when all gadgets are loaded. Events: 1.- dashboard loaded, 2.- addNewFavoriteGadget
    dashboardLoaded (event) {
      const vapp = this
      const customization = this.getCurrentCustomization
      var isFavoritesEnabled = customization.favorites.showFavorites === true
      var isFiltersEnabled = customization.filters.showFilters === true
      if (event.data === 'dashboardloaded') {
        // adjust dashboard after all gadgets are loaded
        window.dispatchEvent(new Event('resize'))

        // LOAD FAVORITES IF ABLE
        if (isFavoritesEnabled) {
          console.log('load favorites on dashboard loaded')
          this.loadFavorites()
        }

        // LOAD FILTERS IF ABLE
        if (isFiltersEnabled) {
          vapp.loadFilters()
        }
      }

      if (event.data === 'addNewFavoriteGadget') {
        // RELOAD FAVORITES AFTER CREATE A NEW ONE
        // console.log('load favorites after create a new one...')
        if (isFavoritesEnabled) { this.loadFavorites() }
      }
    },

    // TO-DO: MAKE DYNAMICAL check for filters in session and trigger
    checkFilters () {
      // get initialdatalink
      this.checkInitialFilters()

      // set for initialdatalink
      this.initialDatalink = this.getInitialDataLink
      // console.log('CHECKFILTERS, InitialDataLink: ', JSON.stringify(this.initialDatalink))

      // finally load dashboard
      console.log('loading Dashboard... ', this.currentDashboardId)
      this.swapBoard(this.currentDashboardId)
    },

    // DASHBOARD EVENT: gadget select
    gadgetSelect (e) {
      const vapp = this
      vapp.jsongadget = e.detail
    },

    // AUX: CHECK if a obj and key exists.-
    checkExists (key, obj) {
      obj = obj || window
      key = key.split('.') || key
      if (typeof obj !== 'object') {
        return false
      }
      while (key.length && (obj = obj[key.shift()]) && typeof obj === 'object' && obj !== null) {
        return (!key.length && typeof obj !== 'undefined')
      }
    },

    // RESIZE DASHBOARD
    resize () {
      if (this.checkExists('inst1', window.DSApi)) { window.DSApi.inst1.api.forceRender() }
    }
  },
  computed: {
    // COMPUTED STORE GETTERS
    ...mapGetters({
      isMultipleApp: 'isMultipleApp',
      getCurrentApplication: 'getCurrentApplication',
      globalFilters: 'getGlobalFilters',
      getGlobalFilters: 'getGlobalFilters',
      getFilterList: 'getFilterList',
      getUser: 'getUser',
      getGlobalIsLoaded: 'getGlobalIsLoaded',
      getInitialDataLink: 'getInitialDataLink',
      getCurrentCustomization: 'getCurrentCustomization'
    }),

    // ALLOW EDIT MODE FOR FAVORITE DASHBOARD
    handleEditMode: function () {
      var editMode = false
      var favoriteDashboard = this.isMultipleApp ? sessionStorage.username + '_' + this.getCurrentApplication + '_fav' : sessionStorage.username + '_fav'
      editMode = this.currentDashboard === favoriteDashboard
      console.log('EDIT MODE: ', editMode)
      return editMode
    }
  },
  // LET DASHBOARD READY FOR THE NEXT LOAD
  beforeDestroy: function () {
    window.removeEventListener('gadgetloaded', this.gadgetLoaded)
    window.removeEventListener('message', this.dashboardLoaded)
    window.removeEventListener('gadgetselect', this.gadgetSelect)
    window.removeEventListener('resize', this.resize)
  },
  created () {
    // LOAD DYN FILTERS IF NOT LOADED
    if (!this.getGlobalIsLoaded) { this.initGlobalFilters() }
  },
  mounted () {
    // WHEN GADGET LOADED
    window.addEventListener('gadgetloaded', this.gadgetLoaded)

    // DASHBOARD MESSAGES
    window.addEventListener('message', this.dashboardLoaded)

    // WHEN GADGET SELECT
    window.addEventListener('gadgetselect', this.gadgetSelect)

    // WHEN DASHBOARD RESIZE IT
    window.addEventListener('resize', this.resize)

    // GADGET FAVORITE ADD APPID
    window.gfmetainf = this.isMultipleApp ? 'app=' + this.getCurrentApplication : ''
  }
}
</script>

<style scoped lang="scss">
.containerDashboard {
  &__layout {
    display: flex !important;
  }

  &__dashboard {
    width: 100% !important;
    overflow: hidden;
    margin: rem(0);
    position: relative;
  }
}
</style>
